<template>
  <div class="computed-sample">
    <label for="fullName">フルネーム:</label>
    <input type="text" id="fullName" v-model="fullName" />
    <br />
    <label for="lastName">名字:</label>
    <input type="text" id="lastName" v-model="lastName" />
    <br />
    <label for="firstName">名前:</label>
    <input type="text" id="firstName" v-model="firstName" />
  </div>
</template>

<script>
import Vue from 'vue'
import { computed, value } from 'vue-function-api'

export default {
  name: 'ComputedSample',

  setup() {
    const firstName = value('')
    const lastName = value('')

    const fullName = computed(
      () => `${lastName.value} ${firstName.value}`.trim(),
      newValue => {
        const [newLastName, newFirstName] = newValue.split(' ')

        firstName.value = newFirstName || ''
        lastName.value = newLastName || ''
      }
    )

    return {
      firstName,
      fullName,
      lastName
    }
  }
}
</script>
